import { render, staticRenderFns } from "./CreateMGate.vue?vue&type=template&id=77493d66&scoped=true"
import script from "./CreateMGate.vue?vue&type=script&lang=js"
export * from "./CreateMGate.vue?vue&type=script&lang=js"
import style0 from "./CreateMGate.vue?vue&type=style&index=0&id=77493d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77493d66",
  null
  
)

export default component.exports